import { render } from "./ColumnBar.vue?vue&type=template&id=4a8b36f3&scoped=true"
import script from "./ColumnBar.vue?vue&type=script&lang=js"
export * from "./ColumnBar.vue?vue&type=script&lang=js"

import "./ColumnBar.vue?vue&type=style&index=0&id=4a8b36f3&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8b36f3"],['__file',"src/vab/layouts/VabLayoutColumn/components/ColumnBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a8b36f3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a8b36f3', __exports__)) {
    console.log('reload')
    api.reload('4a8b36f3', __exports__)
  }
  
  module.hot.accept("./ColumnBar.vue?vue&type=template&id=4a8b36f3&scoped=true", () => {
    console.log('re-render')
    api.rerender('4a8b36f3', render)
  })

}


export default __exports__